import { createSvgIcon } from "@mui/material/utils";

const ListIcon = createSvgIcon(
  <svg
    width="19"
    height="16"
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.25 1.3335C0.25 0.64314 0.809644 0.083496 1.5 0.0834959C2.19036 0.0834958 2.75 0.64314 2.75 1.3335C2.75 2.02385 2.19036 2.5835 1.5 2.5835C0.809645 2.5835 0.25 2.02385 0.25 1.3335ZM5.66667 1.33349C5.66667 0.873258 6.03976 0.500161 6.5 0.500161L17.3333 0.50016C17.7936 0.500159 18.1667 0.873255 18.1667 1.33349C18.1667 1.79373 17.7936 2.16683 17.3333 2.16683L6.5 2.16683C6.03976 2.16683 5.66667 1.79373 5.66667 1.33349ZM0.250001 8.00016C0.250001 7.30981 0.809645 6.75016 1.5 6.75016C2.19036 6.75016 2.75 7.30981 2.75 8.00016C2.75 8.69052 2.19036 9.25016 1.5 9.25016C0.809646 9.25016 0.250002 8.69052 0.250001 8.00016ZM5.66667 8.00016C5.66667 7.53992 6.03976 7.16683 6.5 7.16683L17.3333 7.16683C17.7936 7.16683 18.1667 7.53992 18.1667 8.00016C18.1667 8.4604 17.7936 8.83349 17.3333 8.83349L6.5 8.83349C6.03976 8.83349 5.66667 8.4604 5.66667 8.00016ZM0.250003 14.6668C0.250002 13.9765 0.809646 13.4168 1.5 13.4168C2.19036 13.4168 2.75 13.9765 2.75 14.6668C2.75 15.3572 2.19036 15.9168 1.5 15.9168C0.809647 15.9168 0.250003 15.3572 0.250003 14.6668ZM5.66667 14.6668C5.66667 14.2066 6.03977 13.8335 6.5 13.8335L17.3333 13.8335C17.7936 13.8335 18.1667 14.2066 18.1667 14.6668C18.1667 15.1271 17.7936 15.5002 17.3333 15.5002L6.5 15.5002C6.03977 15.5002 5.66667 15.1271 5.66667 14.6668Z"
      fill="currentColor"
    />
  </svg>,
  "List"
);

export default ListIcon;
